module.exports = __webpack_public_path__ + "static/img/bottom_logo.84c7d72b.png";